import React, { useState } from 'react';
import { SearchBox, AutoComplete } from 'tea-component';
import { ISearchSelectorProps } from '../../type';
import './index.scss';
import classNames from 'classnames';

const SearchSelector = (props: ISearchSelectorProps) => {
  const {
    placeholder = '',
    options = [],
    onSearchValueChange,
    onSearch,
    onClearSearch,
    className,
  } = props;

  const [searchValue, setSearchValue] = useState<string>('');

  const [openAuto, setOpenAuto] = useState(false);

  const onChange = (value: string) => {
    setOpenAuto(!!value);
    setSearchValue(value);
    onSearchValueChange?.(value);
  };

  // 回车搜索
  const onAutoSearch = (value: string) => {
    const option = options?.find((opt) => opt.value === value);
    setSearchValue(option?.name as string);
    // 回车后控制面板消失
    setOpenAuto(false);
    onSearch?.(option?.name as string);
  };

  const onSearchEnter = (value?: string) => {
    onSearch?.(value);
    setOpenAuto(false);
  };

  const onClear = () => {
    setSearchValue('');
    onClearSearch?.();
  };

  return (
    <AutoComplete
      open={!!searchValue && openAuto}
      placementOffset={1}
      overlayClassName={classNames(className,'dbh-search-selector-overlay')}
      options={options}
      onChange={onAutoSearch}
    >
      {(ref) => (
        <SearchBox
          ref={ref}
          placeholder={placeholder}
          value={searchValue}
          onSearch={onSearchEnter}
          onChange={onChange}
          onClear={onClear}
          className="dbh-search-selector-input-box"
        />
      )}
    </AutoComplete>
  );
};

export default SearchSelector;
